import React, {Component} from "react"
import {withTranslate} from "react-redux-multilingual";
import {cancelPlanUrl, getHeader, requestPlanUrl} from "../config";
import axios from "axios";
import SweetAlert from 'react-bootstrap-sweetalert';
import {profile} from "../store/actions/userActions";
import {connect} from "react-redux";
import {callLightBox, initLightBox} from "./../payment_getway/paysky";

class PlanCard extends Component {
    state = {
        /**********inRequest Or showPlan*********/
        is_request: false,

        /*******requestPlan********/
        showRequestPlanSweetAlert: false,
        requestPlanSweetAlertTitle: null,
        requestPlanSweetAlertText: null,
        confirmRequestPlanSweetAlertText: null,
        confirmRequestPlanBtnText: null,
        showSuccessPlanSweetAlert: false,
        /*******cancelPlan********/
        showCancelPlanSweetAlert: false,

        /*******Error on cancel plan********/
        showErrorCancelSweetAlert: false,
        /*******auth request********/
        showAuthSweetAlert: false,
        authSweetAlertTitle: null,
        authSweetAlertText: null,
        /*******change request********/
        showChangePlanRequestSweetAlert: false,
        changePlanRequestSweetAlertTitle: null,
        changePlanRequestSweetAlertText: null,
        /*******get plan request********/
        getPlanRequestSweetAlert: false,
        /***********requestPlanData*******/
        request: {
            plan_id: this.props.plan ? this.props.plan.id : null,
            type: null,
        },

        loading: false,
    };

    componentDidMount() {
        // init payment API
        initLightBox();
        const script = document.createElement("script");
        script.src = "https://grey.paysky.io:9006/invchost/JS/LightBox.js";
        script.async = true;
        document.body.appendChild(script);
    }

    onConfirmSweetAlert = (e, type) => {
        if (type === "validation") {
            this.setState({
                showRequestPlanSweetAlert: false,
            });
        } else if (type === "not_enough_points") {
            window.location.href = "/cash-back";
        }
    };
    goToProfile = () => {
        window.location.href = "/profile";
        this.setState({
            showSuccessPlanSweetAlert: false
        });
    };
    requestPlan = (e) => {
        e.preventDefault();
        // stop loading
        this.setState({
            loading: true,
        });
        const access_token = JSON.parse(window.localStorage.getItem("access_token"));

        if (!access_token) {

            // this.setState({
            //     loading: false,
            //     showAuthSweetAlert: true,
            //     authSweetAlertTitle: this.props.translate("not_login_request_plan_title"),
            //     authSweetAlertText: this.props.translate("not_login_request_plan_text"),
            // });
            // localStorage.setItem("reservation", JSON.stringify(cachedData));
            this.setState({
                loading: false,
            });
            this.props.changeAuthFormStatus(e, "open");
            this.props.changeAuthPopUpStatus(true);
        } else {
            if (this.props.authUser.is_premium === 1 && this.props.authUser.plan && this.props.authUser.plan.id) {
                this.setState({
                    loading: false,
                    showChangePlanRequestSweetAlert: true,
                    changePlanRequestSweetAlertTitle: this.props.translate("change_plan_request_title"),
                    changePlanRequestSweetAlertText: this.props.translate("change_plan_request_text"),
                })
            } else {
                this.setState({
                    loading: false,
                    getPlanRequestSweetAlert: true,
                });
            }
        }
    };
    onConfirmGetPlanSweetAlert = () => {
        this.setState({
            loading: true,
            getPlanRequestSweetAlert: false,
            showChangePlanRequestSweetAlert: false,
        });
        /************* credit card *********/
        if (this.state.request.type == 0) {
            callLightBox(this.props.plan.price, this.props.authUser.unique_id, (data) => {
                this.setState({
                    loading: false,
                    request: {
                        ...this.state.request,
                        transaction_id: data.SystemReference
                    }
                });
                this.requestPlanAxios();
            }, () => {
                this.setState({
                    loading: false,
                    showErrorCancelSweetAlert: true
                })
            }, () => {
                this.setState({
                    loading: false,
                })
            });
        } else {
            /************* cash back *********/
            this.requestPlanAxios();
        }
    };

    requestPlanAxios = () => {
        this.setState({
            loading: true,
            showChangePlanRequestSweetAlert: false,
        });

        axios.post(requestPlanUrl, this.state.request, {headers: getHeader()}).then(res => {
            // stop loading
            this.setState({
                loading: false,
            });
            if (res.data.Error.code === 20) {
                this.setState({
                    showSuccessPlanSweetAlert: true
                });
            } else {
                switch (res.data.Error.code) {
                    case 24 :
                        this.setState({
                            showRequestPlanSweetAlert: true,
                            requestPlanSweetAlertTitle: this.props.translate("something_wrong"),
                            requestPlanSweetAlertText: res.data.Error.desc,
                            confirmRequestPlanSweetAlertText: "validation",
                            confirmRequestPlanBtnText: this.props.translate("ok"),
                        });
                        break;
                    case 22:
                        this.setState({
                            showRequestPlanSweetAlert: true,
                            requestPlanSweetAlertTitle: this.props.translate("not_enough_points"),
                            requestPlanSweetAlertText: res.data.Error.desc,
                            confirmRequestPlanSweetAlertText: "not_enough_points",
                            confirmRequestPlanBtnText: this.props.translate("get_cash_back"),
                        });
                        break;
                    default:

                }
            }
        }).catch(error => {
            console.log(error);
            this.setState({
                loading: true,
            });
        })
    }
    cancelPlan = () => {
        this.setState({
            showCancelPlanSweetAlert: true,
        })
    };
    cancelPlanConfirmation = () => {
        // stop loading
        this.setState({
            loading: true,
        });
        axios.post(cancelPlanUrl, {}, {headers: getHeader()}).then(res => {
            // stop loading
            this.setState({
                loading: false,
            });
            if (res.data.Error.code === 20) {
                this.setState({
                    showCancelPlanSweetAlert: false,
                });
                this.props.profile();
            } else {
                switch (res.data.Error.code) {
                    case 22:
                        this.setState({
                            showErrorCancelSweetAlert: true,
                        });
                        break;
                    default:

                }
            }
        }).catch(error => {
            console.log(error);
            // stop loading
            this.setState({
                loading: false,
            });
        })
    };
    handleRadioButtonChange = (e) => {
        e.target.check = true;
        this.setState({
            request: {
                ...this.state.request,
                type: e.target.value,
            }
        });
    };

    render() {
        const plan_id = this.props.authUser && this.props.authUser.is_premium === 1 ? (this.props.authUser.plan !== null ? this.props.authUser.plan.id : null) : null;
        // const plan_id = this.props.authUser ? (this.props.authUser.plan !== null ? this.props.authUser.plan.id : null) : null;
        //const plan_expired = this.props.authUser ? (this.props.authUser.premium !== null ? this.props.authUser.premium.expiry_date : null) : null;

        return (
            <div id="plan-card">
                {this.props.plan ?
                    <div id="plan-details" hidden={this.state.is_request}>
                        <p>
                        <span
                            className="font-20 bolder light-black">{this.props.plan.price + " " + this.props.translate("currency") + " /"} </span>
                            <span
                                className="font-15 light-black">{this.props.plan.months + " " + this.props.translate("months")}  </span>
                        </p>
                        {/*  <hr/>
                        <p>{this.props.translate("get_plan_with_points") + " "}</p>
                        <p className="gold"><img src="/images/money-bag.png"
                                                 alt="money"/>{this.props.plan.points + " " + this.props.translate("point_s")}
                        </p>*/}
                        <hr/>
                        <div id="plan-request">
                            <label
                                className={plan_id === this.props.plan.id ? "radio-container cursor-not-allowed" : "radio-container"}>{this.props.translate("cash_back")}
                                <input type="radio" disabled={plan_id === this.props.plan.id}
                                       name="type" value={1} onClick={this.handleRadioButtonChange}/>
                                <span className="checkmark"></span>
                            </label>
                            <label
                                className={plan_id === this.props.plan.id ? "radio-container cursor-not-allowed" : "radio-container"}>{this.props.translate("credit_card")}
                                <input type="radio" name="type" disabled={plan_id === this.props.plan.id}
                                       value={0} onClick={this.handleRadioButtonChange}/>
                                <span className="checkmark"></span>
                            </label>
                        </div>
                        <div className="relative">
                            <button onClick={(e) => this.requestPlan(e)}
                                    hidden={plan_id === this.props.plan.id}
                                    className="cursor-pointer gold-btn">{this.props.translate("get_plan")}</button>
                            <button onClick={(e) => this.cancelPlan(e)}
                                    className="btn-danger cursor-pointer gold-btn"
                                    hidden={plan_id !== this.props.plan.id}>
                                {this.props.translate("cancel")}
                            </button>
                            <span id="loading" className="auth-loading" style={{left: "70%"}}
                                  hidden={this.state.loading === false}>
                                                    <img style={{width: "30px", height: "30px", marginTop: "15px"}}
                                                         src="/images/loading-white.svg" alt="loading"/>
                                                </span>
                        </div>
                        {/********************* Get Plan Request for submission ************/}
                        <SweetAlert
                            show={this.state.getPlanRequestSweetAlert}
                            title={this.props.translate("are_you_sure")}
                            onConfirm={() => this.onConfirmGetPlanSweetAlert()}
                            showCancel
                            warning
                            confirmBtnBsStyle="sweet success-sweet"
                            cancelBtnBsStyle="sweet custom-danger"
                            confirmBtnText={this.props.translate("yes")}
                            onCancel={() => this.setState({getPlanRequestSweetAlert: false})}>
                            {this.props.translate("are_you_sure_you_want_get_this_plan")}
                        </SweetAlert>
                        {/********************* Request Plan*********************/}
                        <SweetAlert
                            show={this.state.showRequestPlanSweetAlert}
                            title={this.state.requestPlanSweetAlertTitle}
                            onConfirm={(e) => this.onConfirmSweetAlert(e, this.state.confirmRequestPlanSweetAlertText)}
                            confirmBtnText={this.state.confirmRequestPlanBtnText}
                            showCancel
                            warning
                            cancelBtnBsStyle="sweet custom-danger"
                            confirmBtnBsStyle="sweet success-sweet"
                            onCancel={() => this.setState({showRequestPlanSweetAlert: false})}>
                            {this.state.requestPlanSweetAlertText}
                        </SweetAlert>
                        {/***************************SuccessRequestPlanSweetAlert *******************************/}
                        <SweetAlert
                            show={this.state.showSuccessPlanSweetAlert}
                            title={this.props.translate("success")}
                            onConfirm={() => this.goToProfile()}
                            warning
                            confirmBtnBsStyle="sweet success-sweet"
                            confirmBtnText={this.props.translate("ok")}>
                            {this.props.translate("success_plan")}
                        </SweetAlert>
                        {/*************************CancelPlanSweetAlert******************/}
                        <SweetAlert
                            show={this.state.showCancelPlanSweetAlert}
                            title={this.props.translate("cancel_plan_sweet_alert_title")}
                            onConfirm={(e) => this.cancelPlanConfirmation(e)}
                            showCancel
                            warning
                            cancelBtnBsStyle="sweet custom-danger"
                            confirmBtnBsStyle="sweet success-sweet"
                            onCancel={() => this.setState({showCancelPlanSweetAlert: false})}
                            confirmBtnText={this.props.translate("ok")}>
                            {this.props.translate("cancel_plan_sweet_alert_text")}
                        </SweetAlert>
                        {/***************************ErrorCancelPlanSweetAlert *******************************/}
                        <SweetAlert
                            show={this.state.showErrorCancelSweetAlert}
                            title={this.props.translate("error")}
                            warning
                            confirmBtnBsStyle="sweet success-sweet"
                            onConfirm={() => this.setState({showErrorCancelSweetAlert: false})}
                            confirmBtnText={this.props.translate("ok")}>
                            {this.props.translate("something_wrong")}
                        </SweetAlert>
                        {/***************************NotAuthSweetAlert *******************************/}
                        <SweetAlert
                            show={this.state.showAuthSweetAlert}
                            title={this.state.authSweetAlertTitle}
                            onConfirm={() => this.setState({showAuthSweetAlert: false})}
                            warning
                            confirmBtnBsStyle="sweet success-sweet"
                            confirmBtnText={this.props.translate("ok")}>
                            {this.state.authSweetAlertText}
                        </SweetAlert>
                        {/***************************Change Plan *******************************/}
                        <SweetAlert
                            show={this.state.showChangePlanRequestSweetAlert}
                            title={this.state.changePlanRequestSweetAlertTitle}
                            showCancel
                            warning
                            cancelBtnBsStyle="sweet custom-danger"
                            confirmBtnBsStyle="sweet success-sweet"
                            onCancel={() => this.setState({showChangePlanRequestSweetAlert: false})}
                            onConfirm={() => this.onConfirmGetPlanSweetAlert()}
                            confirmBtnText={this.props.translate("submit")}>
                            {this.state.changePlanRequestSweetAlertText}
                        </SweetAlert>
                        {/* <p hidden={plan_id !== this.props.plan.id}>
                        <span>{this.props.translate("expired_on") + " "}</span>
                        <span className="dark-blue bolder">{plan_expired}</span></p>*/}
                        {/*   <button onClick={(e) => this.cancelPlan(e)} className="cursor-pointer gold-btn"
                            hidden={plan_id !== this.props.plan.id}>{this.props.translate("cancel")}</button>*/}
                        {/* <button onClick={(e) => this.cancelPlan(e)} className="cursor-pointer"
                            hidden={plan_id !== this.props.plan.id}>{this.props.translate("cancel")}</button>
                    ***************************CancelPlanSweetAlert ********************************/}
                    </div>
                    : null}
                {/*
                <div id="plan-request" hidden={!this.state.is_request}>
                    <label className="radio-container">{this.props.translate("points")}
                        <input type="radio" name="plan" onClick={() => this.setState({
                            request: {
                                ...this.state.request,
                                type: 1
                            }
                        })}/>
                        <span className="checkmark"></span>
                    </label>
                    <hr/>
                    <label className="radio-container cursor-not-allowed">{this.props.translate("credit_card")}
                        <input type="radio" name="plan" disabled={true} onClick={() => this.setState({
                            request: {
                                ...this.state.request,
                                type: 0
                            }
                        })}/>
                        <span className="checkmark"></span>
                    </label>
                    ***************************RequestPlanSweetAlert *******************************
                    <div className="action-btns">
                        <button className="done-btn cursor-pointer"
                                onClick={(e) => this.requestPlan(e)}>{this.props.translate("done")}</button>
                        <button className="cursor-pointer"
                            onClick={() => this.setState({is_request: false})}>{this.props.translate("cancel")}</button>
                        <SweetAlert
                            show={this.state.showRequestPlanSweetAlert}
                            title={this.state.requestPlanSweetAlertTitle}
                            onConfirm={(e) => this.onConfirmSweetAlert(e, this.state.confirmRequestPlanSweetAlertText)}
                            confirmRequestPlanBtnText={this.state.confirmRequestPlanBtnText}>
                            {this.state.requestPlanSweetAlertText}
                        </SweetAlert>
                    </div>
                </div>
*/}
            </div>

        )
    }
}

const mapStateToProps = (state) => {
    return {
        authUser: state.user.authUser,
    }

};

const mapDispatchToProps = (dispatch) => {
    return {
        profile: () => {
            dispatch(profile())
        },
    }
};
export default connect(mapStateToProps, mapDispatchToProps)(withTranslate(PlanCard))